import ReserveTravel from './assets/projects/reserve-travel.png';
import PFM from './assets/projects/PFM.png';
import Meetups from './assets/projects/Meetups.png';
import Notes from './assets/projects/Notes.png';
import Meals from './assets/projects/Meals.png';
import Cash from './assets/projects/Cash.png';
import RandomeQ from './assets/projects/RandomQ.png';
import AwesomeB from './assets/projects/AwesomeB.png';
import Hitex from './assets/projects/Hitex.png';
import Tindog from './assets/projects/Tindog.png';
import Todo from './assets/projects/Todo.png';
import FreeGames from './assets/projects/FreeGames.png';
import PortfolioT from './assets/projects/PortfolioT.png';
import MyGh from './assets/projects/MyGh.png';
import MarkDown from './assets/projects/MarkDown.png';
import LifeStruggles from './assets/projects/LifeStruggles.png';
import Landing1 from './assets/projects/Landing1.png';
import Glacier from './assets/projects/Glacier.png';
import Dhorni from './assets/projects/DhorniW.png';
import TelenetPro from './assets/projects/TelenetPro.png';
import BrandBazzar from './assets/projects/BrandBazzar.png';
import Miswag from './assets/projects/Miswag.png';
import TaskTracker from './assets/projects/TaskTracker.png';
import Naas from './assets/projects/Naas.png';
import AOne from './assets/projects/AOne.png';
import OrderManagement from './assets/projects/OrderManagement.png';
import WareHouse from './assets/projects/WareHouse.png';

import Shahez from './assets/Recommendations/Shahez.jpeg';
import Jonathan from './assets/Recommendations/Jonathan.jpeg';
import Alexandre from './assets/Recommendations/Alexandre.jpeg';
import Muzaffer from './assets/Recommendations/Muzaffer.jpeg';
import Fariaa from './assets/Recommendations/Fariaa.jpeg';

const Projects = [
  {
    title: 'Brand Bazzar',
    description:
      'E-commerce website, with payment Integration, user authentication, and admin/vendor panel for managing products and orders.',
    techs: ['Laravel', 'MySQL', 'HTML', 'CSS', 'PHP', 'Composer', 'GoDaddy'],
    Llink: 'https://brandbazzarr.com/',
    GLink: 'https://github.com/Mhamad-Raad/E-Commerce',
    img: BrandBazzar,
  },
  {
    title: 'Telenet Pro',
    description:
      'A website for a company that provides services in the field of telecommunications and information technology.',
    techs: [
      'Next',
      'React Three Fiber',
      'HTML',
      'CSS',
      'TailWind',
      'Npm',
      'AWS',
    ],
    Llink: 'https://telle-net.vercel.app/',
    GLink: 'https://github.com/Mhamad-Raad/TelleNet',
    img: TelenetPro,
  },
  {
    title: 'Dhorni',
    description:
      'A website for a company that provides services in the field of Crypto and investment.',
    techs: ['Next', 'HTML', 'CSS', 'TailWind', 'Npm'],
    Llink: 'https://dohrnii.io/',
    GLink: '',
    img: Dhorni,
  },
  {
    title: 'Order Management',
    description:
      'A Trello-like application for manaing orders, Challenge by Akkoo company.',
    techs: [
      'TypeScript',
      'HTML',
      'CSS',
      'Material UI',
      'Npm',
      'React',
      'Vite',
      'DnD',
      'Redux',
    ],
    Llink: 'https://order-management-akkoo-challenge.vercel.app/',
    GLink: 'https://github.com/Mhamad-Raad/Order-Management-Akkoo-Challenge',
    img: OrderManagement,
  },
  {
    title: 'WareHouse Management',
    description: 'A Warehouse Item Management Website that has three users',
    techs: [
      'JavaScript',
      'HTML',
      'CSS',
      'Tailwind',
      'Npm',
      'React',
      'Localization',
      'Dark Theme',
    ],
    Llink: 'https://mini-market-three.vercel.app/',
    GLink: 'https://github.com/Mhamad-Raad/MiniMarket',
    img: WareHouse,
  },
  {
    title: 'AOne',
    description:
      'A Windows application used for warehouse management for multiple vendors',
    techs: [
      'Electron',
      'Express',
      'HTML',
      'CSS',
      'TailWind',
      'JavaScript',
      'Npm',
    ],
    Llink: '',
    GLink: 'https://github.com/A-One-Org/A1-Frontend',
    img: AOne,
  },
  {
    title: 'Glacier',
    description:
      'A demo version of a website for a company that provides services in the field of trading in crypto currency.',
    techs: ['Next', 'HTML', 'CSS', 'TailWind', 'Npm'],
    Llink: 'https://glacier-nine.vercel.app/',
    GLink: 'https://github.com/Mhamad-Raad/Glacier',
    img: Glacier,
  },
  {
    title: 'Travel Reservation',
    description:
      'Microverse graduation project that lets you sign up, add/delete travels, reserve a travel, and see your reservation history. Bon voyage!.',
    techs: [
      'React',
      'Redux',
      'React Router 6.4',
      'Ruby on Rails',
      'Rspec',
      'JWT',
      'Jest',
    ],
    Llink: 'https://remarkable-buttercream-3be0d2.netlify.app',
    GLink: 'https://github.com/Mhamad-Raad/final-capstone-frontend',
    img: ReserveTravel,
  },
  {
    title: 'Naas Challenge',
    description: 'Company Portfolio challenge that has been created by Naas',
    techs: [
      'Next',
      'React',
      'Tailwind',
      'HTML',
      'CSS',
      'JavaScript',
      'GraphJs',
      'Npm',
      'Versel',
    ],
    Llink: 'https://naas-project.vercel.app/',
    GLink: 'https://github.com/Mhamad-Raad/Naas-Project',
    img: Naas,
  },
  {
    title: 'Finance Manager',
    description:
      'Introducing Finance Manager - Gateway project! Track income, expenses, and save links for later returns. Manage your money like a pro!',
    techs: ['Remix', 'SCSS', 'HTML', 'JavaScript', 'Firabase', 'Yarn'],
    Llink: 'https://money-management-zeta.vercel.app/',
    GLink: 'https://github.com/Mhamad-Raad/PFM-With-Remix',
    img: PFM,
  },
  {
    title: 'Task Manager',
    description:
      'Local task manager that lets you add, delete, and mark tasks as done.',
    techs: ['Angular', 'NGx', 'HTML', 'CSS', 'JavaScript', 'Local Storage'],
    Llink: 'https://task-manager-angular-blond.vercel.app/',
    GLink: 'https://github.com/Mhamad-Raad/task-manager-angular',
    img: TaskTracker,
  },
  {
    title: 'Miswag Challenge',
    description: 'Local E-commerce challenge that has been created by Miswag',
    techs: [
      'Vue',
      'Nuxt',
      'Taiwlind',
      'HTML',
      'CSS',
      'JavaScript',
      'Json',
      'Versel',
    ],
    Llink: 'https://miswag.vercel.app/',
    GLink: 'https://github.com/Mhamad-Raad/Miswag',
    img: Miswag,
  },

  {
    title: 'Random Quote',
    description:
      'Get inspired with this website that generates random quotes! With just a click, stimulate your mind ;)',
    techs: ['React', 'HTML', 'CSS', 'Javascript', 'Npm', 'API'],
    Llink: 'https://random-quote-seven-tan.vercel.app/',
    GLink: 'https://github.com/Mhamad-Raad/random-quote',
    img: RandomeQ,
  },

  {
    title: 'Notes',
    description:
      'Looking for a platform to share notes, life advice, or just some good jokes? Look no further! here is the perfect place to share with others. Join us today!',
    techs: ['Remix', 'HTML', 'CSS', 'JavaScript', 'Firebase', 'Npm'],
    Llink: 'https://note-collector-jtl0kbpkm-mhamad-raad.vercel.app/Notes',
    GLink: 'https://github.com/Mhamad-Raad/Remix-Notes',
    img: Notes,
  },
  {
    title: 'Life Struggles',
    description:
      "Inspires hope, reminding individuals to never give up. it serves as a beacon of optimism, guiding users to find light in life's darkest moments. Embrace hope, there is light after the tunnel.",
    techs: [
      'React',
      'HTML',
      'CSS',
      'JavaScript',
      'Npm',
      'React Three Fiber',
      'Frammer Motion',
    ],
    Llink: 'https://life-struggles.vercel.app/',
    GLink: 'https://github.com/Mhamad-Raad/Life-Struggles',
    img: LifeStruggles,
  },
  {
    title: 'Landing Page',
    description:
      'captivating showcase of innovative design (Landing Page), seamless user experience, and compelling content. Explore its intuitive interface.',
    techs: ['React', 'HTML', 'SCSS', 'TypeScript', 'TailWind', 'Npm'],
    Llink: 'https://company-website1-ashy.vercel.app/',
    GLink: 'https://github.com/Mhamad-Raad/company-website1',
    img: Landing1,
  },
  {
    title: 'Meetups',
    description:
      'Meetups lets you see and post events around you. Stay up-to-date with local happenings and share your own events with the community.',
    techs: ['Next', 'HTML', 'CSS', 'JavaScript', 'MongoDB', 'Npm'],
    Llink: 'https://next-js-news-odq1sgkbk-mhamad-raad.vercel.app/',
    GLink: 'https://github.com/Mhamad-Raad/NextJS-News',
    img: Meetups,
  },
  {
    title: 'Meals',
    description:
      'Introducing our semi-automated food delivery website! Place your order and our expert cooks will see it from the other side.',
    techs: ['React', 'Context', 'HTML', 'CSS', 'Javascript', 'Npm'],
    Llink: 'https://mhamad-raad.github.io/React-Meals/',
    GLink: 'https://github.com/Mhamad-Raad/React-Meals',
    img: Meals,
  },
  {
    title: 'Cash Flow',
    description:
      "Keep track of your expenses and find out which months you've had the highest spending - and on what. Get a better handle on your finances.",
    techs: ['React', 'HTML', 'CSS', 'Javascript', 'Npm', 'Local Storage'],
    Llink: 'https://mhamad-raad.github.io/React-Cash-Flow/',
    GLink: 'https://github.com/Mhamad-Raad/React-Cash-Flow',
    img: Cash,
  },
  {
    title: 'Todo App',
    description:
      'Get your life in order with this fun React-based Todo app! Add, delete, and mark todos as done in a snap. Never miss a task again!',
    techs: ['React', 'HTML', 'CSS', 'Javascript', 'Npm'],
    Llink: 'https://mhamad-raad.github.io/ToDo-React/',
    GLink: 'https://github.com/Mhamad-Raad/ToDo-React',
    img: Todo,
  },
  {
    title: 'Free Games',
    description:
      'Get your game on! Browse the latest and hottest free games for console and PC all in one place.',
    techs: ['HTML', 'CSS', 'Javascript', 'API'],
    Llink: 'https://mhamad-raad.github.io/Capstone-API/',
    GLink: 'https://github.com/Mhamad-Raad/Capstone-API',
    img: FreeGames,
  },
  {
    title: 'Awesome Books',
    description:
      'A react like structure using vanilla JavaScript, read some books and want to put your favorites in a collection? this is the right place for you!',
    techs: ['HTML', 'CSS', 'Javascript'],
    Llink: 'https://mhamad-raad.github.io/Awesome-Books/',
    GLink: 'https://github.com/Mhamad-Raad/Awesome-Books',
    img: AwesomeB,
  },
  {
    title: 'Hitex',
    description:
      'A simple landing page for a technologies and inventions/innovations event that occurs annually',
    techs: ['HTML', 'CSS', 'Javascript'],
    Llink: 'https://mhamad-raad.github.io/Hitex/',
    GLink: 'https://github.com/Mhamad-Raad/Hitex',
    img: Hitex,
  },
  {
    title: 'Portfolio Template',
    description:
      'A simple portfolio template using HTML, CSS, and JavaScript. Feel free to use it as a template for your own portfolio!',
    techs: ['HTML', 'CSS', 'Javascript'],
    Llink: 'https://mhamad-raad.github.io/Microverse-Portfolio/',
    GLink: 'https://github.com/Mhamad-Raad/Microverse-Portfolio',
    img: PortfolioT,
  },
  {
    title: 'TinDog',
    description:
      'Find paw-some matches for your furry friend with Tindog - the Tinder-like website for dogs. Checkout TinDog!',
    techs: ['HTML', 'CSS', 'Bootstrap'],
    Llink: 'https://mhamad-raad.github.io/tindogAngelaYu-project/',
    GLink: 'https://github.com/Mhamad-Raad/tindogAngelaYu-project',
    img: Tindog,
  },

  {
    title: 'MarkDown',
    description:
      'A simple markdown previewer using React. Type in your markdown and see it rendered in real time!',
    techs: ['React', 'HTML', 'CSS', 'Javascript', 'Npm'],
    Llink: 'https://tiny-salamander-d87f32.netlify.app/',
    GLink: 'https://github.com/Mhamad-Raad/MarkDown',
    img: MarkDown,
  },
  {
    title: 'My Github',
    description:
      'Check out my Github for cool projects including music websites, calculators, and other cool projects just for fun!',
    techs: [
      'Ruby on Rails',
      'TypeScript',
      'Flutter',
      'Jest',
      'yarn',
      'PHP',
      '.NET',
      'Java Servlet',
      'C++',
      'Rduino',
      'etc..',
    ],
    Llink: 'https://github.com/Mhamad-Raad',
    GLink: 'https://github.com/Mhamad-Raad',
    img: MyGh,
  },
];

export const Techs = [
  'React',
  'Next',
  'Remix',
  'Redux',
  'Context',
  'React Router 6.4',
  'React Three Fiber',
  'Jest',
  'JavaScript',
  'TypeScript',
  'HTML',
  'CSS',
  'Bootstrap',
  'TailWind',
  'Frammer Motion',
  'SASS',
  'API',
  'Local Storage',
  'Firebase',
  'MongoDB',
  'Npm',
  'Ruby on Rails',
  'Rspec',
  'Flutter',
  'Yarn',
  'PHP',
  '.NET',
  'Java Servlet',
  'C++',
  'Rduino',
  'Yarn',
  'etc..',
];

export const Recommends = [
  {
    name: 'Shahez Shwana',
    position: 'Product Manager',
    text: 'I had the pleasure of being Mhamad’s direct supervisor ShaTech(Lezan). Mhamad proved himself to be a someone who knows how to take the initiative to get the job done. During the following months of the traineeship, he got a central role within his group and functioned as a great resource for his colleagues. Besides his technical capabilities Mhamad is a solution oriented and delightful person to work it. He brings a very positive energy to the team.',
    img: Shahez,
  },
  {
    name: 'Fariaa Hamed',
    position: 'University Lecturer at Qaiwan (UTM)',
    text: "It is my pleasure to recommend Mhamad, who I taught. he demonstrated tremendous effort and brought a great energy to the enviroment. his interest in understanding how things work lead me to believe that he will be a valuable addition in any team he'll join. moreover he is confident, well-organized, diligent, and capable leader, he has that combination of a positive attitude and the belief that he can always improve. I am confident that he will continue to display the same commitment and diligence in everything he does.",
    img: Fariaa,
  },
  {
    name: 'Jonathan Kayizzi',
    position: 'Full Stack Engineer',
    text: 'I have worked with Mhamad through pair-programming and he is very good with Javascript, HTML & CSS.He is a good team player, he is punctual, always on time, and never afraid of taking on challenges.',
    img: Jonathan,
  },
  {
    name: 'Muzaffer Dler',
    position: 'Quality Assurance Engineer',
    text: 'I have worked with Mhamad for a few weeks on Microverse, and I can say that he is one of the brightest and kindest people I have had the pleasure of knowing. He is great at teamwork and very good with Javascript, HTML and CSS.',
    img: Muzaffer,
  },
  {
    name: 'Alexandre Medina',
    position: 'Full Stack Engineer | Electrical Engineer',
    text: 'I have worked with Mhamad, and He is truly one of the most talented and genuinely kind people I’ve had the chance to work with. He thrives in collaborative environments and has a solid command of JavaScript, HTML, and CSS, along with hands-on experience in React and Tailwind CSS.',
    img: Alexandre,
  },
];

export default Projects;
